import { render, staticRenderFns } from "./DocumentationResponses.vue?vue&type=template&id=202fa04c&scoped=true"
import script from "./DocumentationResponses.vue?vue&type=script&lang=js"
export * from "./DocumentationResponses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202fa04c",
  null
  
)

export default component.exports